<ng-content select=".ellipsis-to-drag"></ng-content>

<div class="labels card-block">
  <div class="base-labels">
    <div class="label" *ngIf="card.type && card.type.name !== 'none'"
         [ngStyle]="{'background-color': '#' + card.type.color, 'color': card.type.name == 'Laminated' ? 'black' : 'white'}">
      {{card.type.shortTitle}}
    </div>
    <div class="label" *ngIf="card.paymentStatus && card.paymentStatus.name !== 'none'"
         style.background-color="#{{card.paymentStatus.color}}">
      CAB: {{card.paymentStatus.shortTitle}}</div>


    <div class="label"
         *ngIf="card.installationPaymentStatus && card.installationPaymentStatus.name !== 'Not applicable'"
         style.background-color="#{{card.installationPaymentStatus.color}}">
      INS: {{card.installationPaymentStatus.shortTitle}}</div>
  </div>
  <!--  <div class="complexity">-->
  <!--    <div class="label jobComplexity" *ngIf="card.jobComplexity"-->
  <!--         style.background-color="#{{card.jobComplexity.color}}">-->
  <!--      {{card.jobComplexity.title}}-->
  <!--    </div>-->
  <!--  </div>-->

</div>
<div class="card-block">
  <div class="project-number">
    {{card.number}}
  </div>
  <div class="project-name">
    {{card.name}}
  </div>
</div>

<!-- <div class="project-name card-block" cdkDragHandle cdkDragStartDelay="500">{{card.name}}</div> -->

<div class="icons-block card-block">
  <div class="alerts-icon icon-block" *ngIf="card.activeAlertsCount > 0">
    <mat-icon>notifications_none</mat-icon>
    <div class="date">
      {{card.activeAlertsCount}}
    </div>
  </div>
  <div class="check-items-icon icon-block" *ngIf="card.incompletePunchItemsCount > 0">
    <div class="hammer-icon"></div>
    <div class="date">
      {{card.incompletePunchItemsCount}}
    </div>
  </div>
  <div class="date-icon icon-block" *ngIf="card.finishDate">
    <!-- <mat-icon>access_time</mat-icon> -->
    <i class="pi pi-clock" style="font-size: 125%"></i>

    <div class="date">
      {{card.finishDate | date: 'MMM d' }}
    </div>
  </div>
</div>
<div class="location-icon card-block" *ngIf="card.location">
  <mat-icon>place</mat-icon>
  {{card.location}}
</div>

<div class="users-block card-block" *ngIf="card.projectManager">
  <div class="user-icon">
    <div class="word-avatar">
      <div class="short-name">
        {{card.projectManager.shortCode}}
      </div>
    </div>
  </div>
</div>

<div class="timer-block card-block"
     *ngIf="card.migratedFromNumber || ((card.cardListName === 'Proposal Queue') || (card.card?.list?.name === 'Proposal Queue')) && (card.proposed) !== null">

  <div class="from-other-system" *ngIf="card.migratedFromNumber">Came From CA</div>
  <div class="from-other-system" *ngIf="card.migratedToNumber">Sent to PROD</div>
  <div class="space-block">

  </div>
  <div class="timer-phon"
       *ngIf="((card.cardListName === 'Proposal Queue') || (card.card?.list?.name === 'Proposal Queue')) && (card.proposed) !== null">{{getCreatedTime(card.proposed)}}</div>
</div>
